import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { Result } from '../../result';
import { environment } from 'src/environments/environment';
// import { AuthGuard } from 'src/app/authentication/guards/auth-guard.service';
import { CommonModel } from '../../common-model';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  getlen: any;
  obj = new CommonModel;

  constructor(private http: HttpClient) {
    this.obj.lan = LocalstorageService.getLanguage("language");
  }

  public GetMarque() {
    // let headers;
    // headers = this.AuthGuardService.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetMarqueData`, this.obj);
  }
  public GetAllModules() {
    // let headers;
    // headers = this.AuthGuardService.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/ListofRoutes/GetAllModules`, this.obj);
  }

}
